import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { State } from "../../store";
import "./style/finalizeWithLoginStyle.scss";
import "../../../style/alerts.scss";
import "../../../style/buttons.scss";
import "../../../style/feature.scss";
import InvoiceButtons from "./InvoiceButtons";
import { SubmitHandler, useForm, get } from "react-hook-form";
import { InputsFinalize } from "./FinalizeNoLogin";
import BasketSummary from "./BasketSummary";
import { FormElementModel } from "../../models/FormElementModel";
import { invoiceForm } from "./inputsForm/InputPayFormModels";
import EATextField from "../shared/TextField/EATextField";
import EANipInput from "../shared/NipInput/EANipInput";
import { useCountryCodes } from "./hooks/useCountryCodes";
import useMyAccount from "../MyAccount/hooks/useMyAccount";
import EcardButton from "./ecardPayment/EcardButton";
import EcardSummary from "./ecardPayment/EcardSummary";
import useFinalizeManager from "./hooks/useFinalizeManager";
import { PaymentLogos } from "../../../features/PaymentLogo";
import { useTranslation } from "react-i18next";
import ReactPixel from "react-facebook-pixel";
import useFacility from "../../../utils/hooks/useFacility";
import RecipientAndPurchaserForm from "./RecipientAndPurchaserForm";
import EAButton from "../shared/Buttons/EAButton";
import ConsentInputs from "./ConsentInputs/ConsentInputs";
import Timer from "./Timer";
import { gaEvent } from "../../../utils/Analitics/ga";
import { canSendToFacebookPixel, canSendToGA } from "../../../utils/Analitics/analiticsConfigByFacility";
import { GA_BEGIN_CHECKOUT } from "../../../utils/Analitics/gaEventsConsts";
import { sendBeginCheckoutEvent, convertBasketToBeginCheckoutFormat } from "../../../utils/Analitics/GtmEvents";
import { BasketItem } from "../../models/BasketItem";
import SubmitButton from "./SubmitButton";

interface IProps {
  onPayTransaction: (value: InputsFinalize) => void;
  onSaveReservation: (value: InputsFinalize) => void;
  alertPayment: string;
  total: number;
  paymentUrl: string;
  loader: boolean;
  basket: BasketItem[];
  promoMessage: string;
  currentPromoCode: string;
}

const FinalizeWithLogin: React.FC<IProps> = ({
  onPayTransaction,
  onSaveReservation,
  alertPayment,
  total,
  paymentUrl,
  loader,
  basket,
  promoMessage,
  currentPromoCode,
}: IProps) => {
  const userData = useSelector((state: State) => state.auth.userData);
  const isB2B = Boolean(userData.b2bType);
  const b2bPaymentType = userData.b2bType as "ePayment" | "downPayment" | "";
  const [invoiceType, setInvoiceType] = useState<
    "noInvoice" | "customerInvoice" | "companyInvoice" | "recipientAndPurchaserInvoice"
  >("noInvoice");
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { t } = useTranslation();
  const { eCardPaymnet, alert } = useFinalizeManager(() => {});
  const [email, setEmail] = useState<string>();
  const facilityIds = useFacility();
  const [hasSubmitted, setHasSubmitted] = useState<boolean>(false);
  const { countryCodes, hasError: countryCodesError } = useCountryCodes();

  useMyAccount();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    setValue,
  } = useForm<InputsFinalize>({
    defaultValues: userData,
  });

  // const handleRefreshBasket = async () => {
  //   //FAKOWE DODAWANIE I USUWANIE KOSZKA TYLKO ABY WYELIMINOWAC BLAD Index: 0 Size: 0
  //   // KOMENTARZUJE PO ROZMOWIE Z DAWIDEM
  //   const { result } = await post(ADD_TO_BASKET_URL, { facilityIds: `0,${facilityIds}` });
  //   await post(REMOVE_ITEM_BASKET_URL, { idx: result.length - 1 });
  // };

  useEffect(() => {
    reset(userData);
    //eslint-disable-next-line
  }, [userData]);

  useEffect(() => {
    if (isB2B) {
      setInvoiceType("companyInvoice");
    }
    //eslint-disable-next-line
  }, [userData, isB2B]);

  useEffect(() => {
    if (isB2B && invoiceType === "companyInvoice") {
      if (userData.name) setValue("companyName", userData.name);
      const nipValue = userData.NIP || (userData as any).nip;
      if (nipValue) setValue("NIP", nipValue);
    }
    //eslint-disable-next-line
  }, [invoiceType, userData]);

  // useEffect(() => {
  //   handleRefreshBasket();
  //   //eslint-disable-next-line
  // }, []);

  const handleRegistration: SubmitHandler<InputsFinalize> = async (data) => {
    setEmail(data.email);

    // Czyszczenie pól faktury firmowej gdy nie wybrano faktury na firmę
    const cleanedData: InputsFinalize = {
      ...data,
      NIP: invoiceType === "companyInvoice" ? data.NIP : "",
      companyName: invoiceType === "companyInvoice" ? data.companyName : "",
      nipCountryCode: invoiceType === "companyInvoice" ? data.nipCountryCode : undefined,
    };

    // Zapisujemy stan koszyka lokalnie przed wykonaniem akcji
    const basketSnapshot = [...basket];
    const totalSnapshot = total;
    const promoCodeSnapshot = currentPromoCode;

    analiticsBeginCheckout(basketSnapshot, totalSnapshot, promoCodeSnapshot);

    // Guard to prevent multiple submissions, particularly for free orders (paymentUrl === "")
    setHasSubmitted(true);

    if (invoiceType === "recipientAndPurchaserInvoice") {
      onSaveReservation({ ...cleanedData, createInvoice: true });
    } else {
      onPayTransaction({ ...cleanedData, createInvoice: invoiceType !== "noInvoice" });
    }

    // pixelAddBasket();
  };

  const [paymentType, setPaymentType] = useState<string>("online");
  const handleSetPayment = (type: string) => {
    setPaymentType(type);
  };

  const analiticsBeginCheckout = (
    basketSnapshot: any[],
    totalSnapshot: number,
    promoCodeSnapshot: string | undefined
  ) => {
    // Calculate total from basket if needed
    const calculatedTotal = basketSnapshot.reduce((sum, item) => sum + item.price * item.qnt, 0);
    const eventValue = totalSnapshot > 0 ? totalSnapshot : calculatedTotal;

    if (canSendToFacebookPixel(facilityIds)) {
      ReactPixel.fbq("track", "basketValueBeforePayU", {
        value: eventValue,
        currency: "PLN",
      });
    }

    // Fix GA Event structure for ecommerce tracking
    if (canSendToGA(facilityIds)) {
      gaEvent(
        facilityIds,
        "ecommerce",
        GA_BEGIN_CHECKOUT,
        {
          event_category: "ecommerce",
          currency: "PLN",
          value: eventValue,
          items: basketSnapshot.map((item: any) => ({
            item_id: item.assortIds.replace(/^0,\+/, ""),
            item_name: item.assortName || "Produkt",
            price: item.price,
            quantity: item.qnt,
          })),
        },
        "begin_checkout"
      );
    }

    // Wysyłanie GTM begin_checkout event
    try {
      const promoCode = promoCodeSnapshot && promoCodeSnapshot.length > 0 ? promoCodeSnapshot : undefined;
      const beginCheckoutData = convertBasketToBeginCheckoutFormat(basketSnapshot, eventValue, promoCode);
      sendBeginCheckoutEvent(facilityIds, beginCheckoutData);
    } catch (error) {
      console.error("Error sending GTM begin_checkout event:", error);
    }
  };

  return (
    <div>
      <form className="finalize-no-login flex-between" onSubmit={handleSubmit(handleRegistration)}>
        <div className="basket-box shadow border">
          {isB2B ? <h3>{t("zakladasz_zamowienie_na")}</h3> : <h3>{t("jestes_zalogowany")}</h3>}

          <div className="form form_looged">
            {!isB2B && <input type="text" value={userData.firstName} />}
            <input type="text" value={userData.email} />
            {!isB2B && <input type="text" value={userData.phone} />}
          </div>

          {isB2B && (
            <div className="b2b-payment-info">
              {b2bPaymentType === "ePayment" && (
                <p className="b2b-payment-info__chip">
                  {t("b2b_ePayment_info", "Płatność online zgodnie z warunkami B2B. Faktura zostanie wystawiona automatycznie.")}
                </p>
              )}
              {b2bPaymentType === "downPayment" && (
                <p className="b2b-payment-info__chip">
                  {t("b2b_downPayment_info", "Faktura z odroczonym terminem płatności zgodnie z umową B2B.")}
                </p>
              )}
            </div>
          )}

          {!isB2B && (
            <>
              <EAButton title={t("wyloguj_sie")} variant="outlined" />

              {saleConfiguration.invoiceActive && (
                <React.Fragment>
                   {paymentType !== "ecard" && <>
                  <h4>{t("faktura")}</h4>
                   
                  <InvoiceButtons invoiceType={invoiceType} setInvoiceType={setInvoiceType} /></>}
                </React.Fragment>
              )}
            </>
          )}
        </div>

        <div className="basket-box shadow border">
          {invoiceType !== "noInvoice" && (
            <div>
              {invoiceType === "recipientAndPurchaserInvoice" ? (
                <RecipientAndPurchaserForm register={register} errors={errors} control={control} setValue={setValue} countryCodes={countryCodes} countryCodesError={countryCodesError} />
              ) : (
                <>
                  <h3>{t("dane_do_faktury")}</h3>
                  <div className={"inputs-customer-invoice"}>
                    {invoiceForm(register, invoiceType === "companyInvoice").map(
                      (item: FormElementModel, index: number) => (
                        <React.Fragment key={index}>
                          {item.name === "street" && invoiceType === "companyInvoice" && (
                            <EANipInput
                              control={control}
                              name="NIP"
                              countryCodeFieldName="nipCountryCode"
                              setValue={setValue}
                              errors={errors}
                              label={t("nip")}
                              countries={countryCodes}
                              showCountrySelect={!countryCodesError}
                              fullWidth
                            />
                          )}
                          {item.name && (
                            <EATextField
                              label={item.text}
                              name={item.name}
                              type={item.type as "text" | "email" | "password" | "number"}
                              placeholder={item.placeholder}
                              register={item.register}
                              error={!!get(errors, item.name)}
                              helperText={get(errors, item.name)?.message}
                              fullWidth
                            />
                          )}
                        </React.Fragment>
                      )
                    )}
                  </div>
                </>
              )}
            </div>
          )}

          {invoiceType === "noInvoice" && (
            <ConsentInputs
              errors={errors}
              control={control}
              setValue={setValue}
              email={email}
              title={t("zgody")}
              newsletter={true}
            />
          )}
        </div>

        <div className="basket-box shadow border">
          {invoiceType !== "noInvoice" && (
            <ConsentInputs
              errors={errors}
              control={control}
              setValue={setValue}
              email={email}
              title={t("zgody")}
              newsletter={true}
            />
          )}
          {paymentType === "online" ? (
            <>
              <BasketSummary total={total} />

              {alertPayment.length > 2 && <div className="alert alert-red">{alertPayment}</div>}

              <SubmitButton loader={loader} paymentUrl={paymentUrl} hasSubmitted={hasSubmitted} />
              <Timer />
              <PaymentLogos />

              <EcardButton handleSetPayment={handleSetPayment}  setInvoiceType={setInvoiceType}/>
            </>
          ) : (
            <>
              <EcardSummary eCardPaymnet={eCardPaymnet} handleSetPayment={handleSetPayment} alert={alert} />
            </>
          )}
        </div>
      </form>
    </div>
  );
};

export default FinalizeWithLogin;
